import { encounterField } from '../../shared/array-types';

type Row = Record<string, unknown>;
const fields = ['in_combat', 'active_combat_id', 'current_round', 'current_encounter_creature_id_turn',
    'turn_phase', 'pending_main_turn_encounter_creature_id', 'legendary_turn_queue'] as const;

/** Keep a retained combat member's header, including lean pointer clears. */
export function readCombatEncounterHeader(encounter: unknown): Row {
    return Object.fromEntries(fields.map(key => [key, encounterField(encounter, key)]));
}

export function applyCombatEncounterHeader(encounter: Row, header: Readonly<Row>): void {
    const bucket = (encounter.encounters ??= {}) as Row;
    for (const key of fields) {
        const value = header[key];
        if (value === undefined) delete bucket[key]; else bucket[key] = value;
        if (key in encounter) { if (value === undefined) delete encounter[key]; else encounter[key] = value; }
    }
}
